import {sprintf} from 'sprintf-js';

export function hasMandatoryUpsells ({ticket}) {
  const {basket} = ticket;

  if (basket && basket.mandatoryUpsells) {
    return true;
  }
  else {
    return false;
  }
}

export function getPriceWithMandatoryUpsells ({ticket}) {
  const {basket, id} = ticket;
  const {rawTickets, mandatoryUpsells, moneyFormat, currency} = basket;
  const rawPrices = rawTickets.map(t => Object.assign({}, t.price, { id: t.id}));

  const pricesWithMU = addMandatoryUpsells(rawPrices, mandatoryUpsells);

  const price = findPriceById(pricesWithMU, id);

  if (!price.priceWithMU) {
    return price.priceFormatted;
  }
  else {
    const total = price.priceWithMU / 100;
    const decimals = Math.round((total % 1) * 100);
    return sprintf(moneyFormat, total, decimals, currency);
  }
}

function addMandatoryUpsells (rawPrices, mandatoryUpsells) {
  if (!mandatoryUpsells) {
    return rawPrices;
  }

  mandatoryUpsells.forEach(mu => {
    for (let i = 0; i < rawPrices.length; i++) {
      const rp = rawPrices[i];

      if (mu.applicableToPriceTypeIds.indexOf(parseInt(rp.priceType, 10)) > -1) {
        if (!rp.priceWithMU) {
          rp.priceWithMU = rp.price + mu.minPrice;
        }
        else {
          rp.priceWithMU += mu.minPrice;
        }
      }
    }
  });

  return rawPrices;
};

function findPriceById (pricesWithMU, id) {
  const ps = pricesWithMU.filter(p => p.id === id);

  return ps[0];
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/mandatory_upsells_utils.js